( function( $ ) {
	
    function modifyList() {
        if( window.device && window.device === 'tablet' && $( window ).width() < 975 ){
            addRemoveExcerptMini( '.homepage', '10', false );
            addRemoveExcerptMini( '.theme-items', '10', false );
            addRemoveExcerptMini( '.article-related', '4', false );
            //addRemoveExcerptMini( '.advice', '10', false );
            addRemoveExcerptMini( '.post-type-archive-article', '10', false );
        } else {
            addRemoveExcerptMini( '.homepage', '10', true );
            addRemoveExcerptMini( '.theme-items', '10', true );
            addRemoveExcerptMini( '.article-related', '4', true );
            //addRemoveExcerptMini( '.advice', '10', true );
            addRemoveExcerptMini( '.post-type-archive-article', '10', true );
        }
    }

    function addRemoveExcerptMini( container, elnr, remove ) {
        if( remove ) {
            if( $( container + ' .excerpt' ).length && !$( container + ' .col-md-4:nth-child(' + elnr + ') .excerpt' ).hasClass( 'excerpt--mini' ) ) {
                $( container + ' .col-md-4:nth-child(' + elnr + ') .excerpt' ).addClass( 'excerpt--mini' );
            }
        } else {
            if( $( container + ' .excerpt' ).length ) {
                $( container + ' .col-md-4:nth-child(' + elnr + ') .excerpt' ).removeClass( 'excerpt--mini' );
            }
        }
    }

    modifyList();


    $( window ).on('resize', function( event ) {
        modifyList();
    } );

} )( jQuery );